export const canPass = (errorObj: any) => {
    let can = true;
    for (let property in errorObj) {
        if (errorObj[property].error) {
            can = false;
        }
    }
    return can;
}